export default __webpack_public_path__ + "static/figure1-7719b25adc9e4247e1d7b19dd03fd9f4.webp";